import { render, staticRenderFns } from "./BannerAdd.vue?vue&type=template&id=b6c9fae6&scoped=true&"
import script from "./BannerAdd.vue?vue&type=script&lang=js&"
export * from "./BannerAdd.vue?vue&type=script&lang=js&"
import style0 from "./BannerAdd.vue?vue&type=style&index=0&id=b6c9fae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c9fae6",
  null
  
)

export default component.exports